import {
  CronoGatewayAction,
  CronoGatewayError,
  CronoGatewayParamsAccount,
  CronoGatewayParamsProspect,
  CronoGatewayResponse,
  requiredExtensionVersionByActionTargetAndMethodName,
} from '../../types/crono-extension';
import { useCallback, useState } from 'react';
import {
  CronoGatewayLinkedinAction,
  CronoGatewayLinkedinDownloadFileAction,
  CronoGatewayLinkedinGetActivitiesAction,
  CronoGatewayLinkedinGetCompanyActivitiesAction,
  CronoGatewayLinkedinGetCompanyExtendedInfoAction,
  CronoGatewayLinkedinGetCompanyInfoAction,
  CronoGatewayLinkedinGetCompanyInfoByNumericIdAction,
  CronoGatewayLinkedinGetCompanyNumericIdAction,
  CronoGatewayLinkedinGetCompanyJobsAction,
  CronoGatewayLinkedinGetContactCommentsAction,
  CronoGatewayLinkedinGetContactExperiencesAction,
  CronoGatewayLinkedinGetContactSocialInteractionsAction,
  CronoGatewayLinkedinGetConversationAction,
  CronoGatewayLinkedinGetConversationIdAction,
  CronoGatewayLinkedinGetFilterValuesAction,
  CronoGatewayLinkedinGetInMailCreditsAction,
  CronoGatewayLinkedinGetInvitationsLimitAction,
  CronoGatewayLinkedinGetLeadIdAction,
  CronoGatewayLinkedinGetProfileIdFromLeadIdAction,
  CronoGatewayLinkedinGetProfileInfoAction,
  CronoGatewayLinkedinGetProfileUrnAction,
  CronoGatewayLinkedinGetProfileViewAction,
  CronoGatewayLinkedinGetSalesNavConversationAction,
  CronoGatewayLinkedinGetSalesNavConversationIdAction,
  CronoGatewayLinkedinGetStatusAction,
  CronoGatewayLinkedinGetThreadReactionsAction,
  CronoGatewayLinkedinGetUserExperienceAction,
  CronoGatewayLinkedinHasSalesNavAction,
  CronoGatewayLinkedinRefreshCurrentSalesNavCookie,
  CronoGatewayLinkedinSearchCompaniesAction,
  CronoGatewayLinkedinSearchLeadsAction,
  CronoGatewayLinkedinSearchSalesNavCompaniesAction,
  CronoGatewayLinkedinSearchSalesNavLeadsAction,
  CronoGatewayLinkedinSendInMailMessageAction,
  CronoGatewayLinkedinSendInvitationAction,
  CronoGatewayLinkedinSendMessageAction,
  CronoGatewayLinkedinSendMessageWithAttachmentAction,
  CronoGatewayLinkedinSendVoiceMessageAction,
  CronoGatewaySalesNavGetSavedSearchesCompanies,
  CronoGatewaySalesNavGetSavedSearchesLeads,
  CronoGatewaySalesNavExecuteSavedSearchLeads,
  CronoGatewaySalesNavExecuteSavedSearchCompanies,
  CronoGatewayLinkedinGetUserProfileInfoAction,
  CronoGatewayLinkedinReactLinkedinActivityAction,
  CronoGatewayLinkedinVisitProfileAction,
  CronoGatewayLinkedinFollowProfileAction,
  CronoGatewayLinkedinMarkConversationAsReadAction,
  CronoGatewayLinkedinGetProfileDescriptionAction,
} from 'crono-fe-common/types/crono-extension/linkedin';
import {
  CronoGatewayBackgoundSendNotificationToCronoApp,
  CronoGatewayBackgroundClearAsyncJobsAction,
  CronoGatewayBackgroundEnqueueAsyncEnrichJobs,
  CronoGatewayBackgroundEnqueueAsyncJobs,
  CronoGatewayBackgroundMarkEnrichJobsAsReadAction,
  CronoGatewayBackgroundInvalidateAutomatorDelay,
  CronoGatewayBackgroundStartAutomator,
  CronoGatewayBackgoundSaveInTaskContext,
  CronoGatewayBackgoundGetTaskContextAndClear,
  CronoGatewayBackgroundMarkJobsAsReadAction,
  CronoGatewayBackgroundOpenOrFocusTabAction,
  CronoGatewayBackgroundReloadExtensionAction,
  CronoGatewayBackgroundLoadImageAction,
  CronoGatewayBackgroundEnqueueAsyncRewriteJobs,
  CronoGatewayBackgroundCheckUpdatesManually,
  CronoGatewayBackgroundInvalidateVoiceNoteCacheAction,
  CronoGatewayBackgroundSyncRewriteQueueAction,
  CronoGatewayBackgroundKeepAlive,
} from 'crono-fe-common/types/crono-extension/background-script';
import {
  compareVersions,
  getCronoChromeExtensionId,
} from 'crono-fe-common/utils';
import { CronoGatewayGoogleSearchPlacesActon } from 'crono-fe-common/types/crono-extension/google';

export interface Analytics {
  identify: (userId: string, traits?: Record<string, unknown>) => Promise<void>;
  group: (groupId: string, traits?: Record<string, unknown>) => void;
  track: (
    eventName: string,
    properties?: Record<string, unknown>,
  ) => Promise<void>;
  user: () => { id: () => string | undefined };
}

// linkedin

export const useLinkedinGetStatus =
  createIpcHook<CronoGatewayLinkedinGetStatusAction>(
    'linkedin',
    'getStatus',
    'prospect',
  );

export const useLinkedinGetUserProfileInfo =
  createIpcHook<CronoGatewayLinkedinGetUserProfileInfoAction>(
    'linkedin',
    'getUserProfileInfo',
    null,
  );
export const useLinkedinSendInvitation =
  createIpcHook<CronoGatewayLinkedinSendInvitationAction>(
    'linkedin',
    'sendInvitation',
    'prospect',
  );

export const useLinkedinSendMessage =
  createIpcHook<CronoGatewayLinkedinSendMessageAction>(
    'linkedin',
    'sendMessage',
    'prospect',
  );

export const useLinkedinSendMessageWithAttachment =
  createIpcHook<CronoGatewayLinkedinSendMessageWithAttachmentAction>(
    'linkedin',
    'sendMessageWithAttachment',
    'prospect',
  );

export const useLinkedinSendVoiceMessage =
  createIpcHook<CronoGatewayLinkedinSendVoiceMessageAction>(
    'linkedin',
    'sendVoiceMessage',
    'prospect',
  );

export const useLinkedinSearchCompanies =
  createIpcHook<CronoGatewayLinkedinSearchCompaniesAction>(
    'linkedin',
    'searchCompanies',
    null,
  );

export const useLinkedinGetActivities =
  createIpcHook<CronoGatewayLinkedinGetActivitiesAction>(
    'linkedin',
    'getActivities',
    'prospect',
  );

export const useLinkedinReactLinkedinActivity =
  createIpcHook<CronoGatewayLinkedinReactLinkedinActivityAction>(
    'linkedin',
    'reactToLinkedinActivity',
    null,
  );

export const useLinkedinGetCompanyActivities =
  createIpcHook<CronoGatewayLinkedinGetCompanyActivitiesAction>(
    'linkedin',
    'getCompanyActivities',
    'account',
  );

export const useLinkedinGetContactComments =
  createIpcHook<CronoGatewayLinkedinGetContactCommentsAction>(
    'linkedin',
    'getContactComments',
    'prospect',
  );

export const useLinkedinGetContactExperiences =
  createIpcHook<CronoGatewayLinkedinGetContactExperiencesAction>(
    'linkedin',
    'getContactExperiences',
    'prospect',
  );

export const useLinkedinGetContactSocialInteractions =
  createIpcHook<CronoGatewayLinkedinGetContactSocialInteractionsAction>(
    'linkedin',
    'getContactSocialInteractions',
    'prospect',
  );

export const useLinkedinGetCompanyInfo =
  createIpcHook<CronoGatewayLinkedinGetCompanyInfoAction>(
    'linkedin',
    'getCompanyInfo',
    'account',
  );

export const useLinkedinGetProfileInfo =
  createIpcHook<CronoGatewayLinkedinGetProfileInfoAction>(
    'linkedin',
    'getProfileInfo',
    'prospect',
  );

export const useLinkedinGetUserExperiences =
  createIpcHook<CronoGatewayLinkedinGetUserExperienceAction>(
    'linkedin',
    'getUserExperience',
    'prospect',
  );

export const useLinkedinGetConversation =
  createIpcHook<CronoGatewayLinkedinGetConversationAction>(
    'linkedin',
    'getConversation',
    'prospect',
  );

export const useLinkedinGetConversationId =
  createIpcHook<CronoGatewayLinkedinGetConversationIdAction>(
    'linkedin',
    'getConversationId',
    'prospect',
  );

export const useLinkedinGetProfileUrn =
  createIpcHook<CronoGatewayLinkedinGetProfileUrnAction>(
    'linkedin',
    'getProfileUrn',
    'prospect',
  );

export const useLinkedinGetLeadId =
  createIpcHook<CronoGatewayLinkedinGetLeadIdAction>(
    'linkedin',
    'getLeadId',
    'prospect',
  );

export const useLinkedinGetSalesNavConversation =
  createIpcHook<CronoGatewayLinkedinGetSalesNavConversationAction>(
    'linkedin',
    'getSalesNavConversation',
    'prospect',
  );

export const useLinkedinGetSalesNavConversationId =
  createIpcHook<CronoGatewayLinkedinGetSalesNavConversationIdAction>(
    'linkedin',
    'getSalesNavConversationId',
    'prospect',
  );

export const useMarkLinkedinConversationAsRead =
  createIpcHook<CronoGatewayLinkedinMarkConversationAsReadAction>(
    'linkedin',
    'markLinkedinConversationAsRead',
    'prospect',
  );

export const useLinkedinSearchLeads =
  createIpcHook<CronoGatewayLinkedinSearchLeadsAction>(
    'linkedin',
    'searchLeads',
    null,
  );

export const useLinkedinSearchSalesNavLeads =
  createIpcHook<CronoGatewayLinkedinSearchSalesNavLeadsAction>(
    'linkedin',
    'searchSalesNavLeads',
    null,
  );

export const useLinkedinSearchSalesNavCompanies =
  createIpcHook<CronoGatewayLinkedinSearchSalesNavCompaniesAction>(
    'linkedin',
    'searchSalesNavCompanies',
    null,
  );

export const useLinkedinGetProfileView =
  createIpcHook<CronoGatewayLinkedinGetProfileViewAction>(
    'linkedin',
    'getProfileView',
    'prospect',
  );

export const useLinkedinGetProfileDescription =
  createIpcHook<CronoGatewayLinkedinGetProfileDescriptionAction>(
    'linkedin',
    'getProfileDescription',
    'prospect',
  );

export const useLinkedinGetExtendedCompanyInfo =
  createIpcHook<CronoGatewayLinkedinGetCompanyExtendedInfoAction>(
    'linkedin',
    'getCompanyExtendedInfo',
    'account',
  );

export const useLinkedinGetCompanyJobs =
  createIpcHook<CronoGatewayLinkedinGetCompanyJobsAction>(
    'linkedin',
    'getCompanyJobs',
    'account',
  );

export const useLinkedinGetPublicIdFromLeadId =
  createIpcHook<CronoGatewayLinkedinGetProfileIdFromLeadIdAction>(
    'linkedin',
    'getPublicIdFromLeadId',
    null,
  );

export const useLinkedinGetCompanyInfoFromNumericId =
  createIpcHook<CronoGatewayLinkedinGetCompanyInfoByNumericIdAction>(
    'linkedin',
    'getCompanyInfoByNumericId',
    null,
  );

export const useLinkedinGetCompanyNumericId =
  createIpcHook<CronoGatewayLinkedinGetCompanyNumericIdAction>(
    'linkedin',
    'getCompanyNumericId',
    'account',
  );

export const useLinkedinGetThreadReactions =
  createIpcHook<CronoGatewayLinkedinGetThreadReactionsAction>(
    'linkedin',
    'getThreadReactions',
    null,
  );

export const useLinkedinHasSalesNav =
  createIpcHook<CronoGatewayLinkedinHasSalesNavAction>(
    'linkedin',
    'hasSalesNav',
    null,
  );

export const useLinkedinGetInvitationsLimit =
  createIpcHook<CronoGatewayLinkedinGetInvitationsLimitAction>(
    'linkedin',
    'getInvitationsLimit',
    null,
  );

export const useLinkedinGetInMailCredits =
  createIpcHook<CronoGatewayLinkedinGetInMailCreditsAction>(
    'linkedin',
    'getInMailCredits',
    null,
  );

export const useLinkedinSendInMailMessage =
  createIpcHook<CronoGatewayLinkedinSendInMailMessageAction>(
    'linkedin',
    'sendInMailMessage',
    'prospect',
  );

export const useLinkedinDownloadFile =
  createIpcHook<CronoGatewayLinkedinDownloadFileAction>(
    'linkedin',
    'downloadFile',
    null,
  );

export const useLinkedinVisitProfile =
  createIpcHook<CronoGatewayLinkedinVisitProfileAction>(
    'linkedin',
    'visitProfile',
    'prospect',
  );

export const useLinkedinFollowProfile =
  createIpcHook<CronoGatewayLinkedinFollowProfileAction>(
    'linkedin',
    'followProfile',
    'prospect',
  );

// background
export const useBackgroundOpenOrFocusTab =
  createIpcHook<CronoGatewayBackgroundOpenOrFocusTabAction>(
    'background-script',
    'openOrFocusTab',
  );

export const useEnqueueAsyncJob =
  createIpcHook<CronoGatewayBackgroundEnqueueAsyncJobs>(
    'background-script',
    'enqueueAsyncJobs',
  );

export const useKeepAlive = createIpcHook<CronoGatewayBackgroundKeepAlive>(
  'background-script',
  'keepAlive',
);

export const useEnqueueAsyncRewriteJob =
  createIpcHook<CronoGatewayBackgroundEnqueueAsyncRewriteJobs>(
    'background-script',
    'enqueueAsyncRewriteJobs',
  );

export const useBackgroundInvalidateVoiceNoteCache =
  createIpcHook<CronoGatewayBackgroundInvalidateVoiceNoteCacheAction>(
    'background-script',
    'invalidateVoiceNoteCache',
  );

export const useBackgroundClearAsyncJobs =
  createIpcHook<CronoGatewayBackgroundClearAsyncJobsAction>(
    'background-script',
    'clearAsyncJobs',
  );

export const useBackgroundMarkJobsAsRead =
  createIpcHook<CronoGatewayBackgroundMarkJobsAsReadAction>(
    'background-script',
    'markJobsAsRead',
  );

export const useSyncRewriteQueue =
  createIpcHook<CronoGatewayBackgroundSyncRewriteQueueAction>(
    'background-script',
    'syncRewriteQueue',
  );

export const useEnqueueAsyncEnrichJob =
  createIpcHook<CronoGatewayBackgroundEnqueueAsyncEnrichJobs>(
    'background-script',
    'enqueueAsyncEnrichJobs',
  );

export const useBackgroundMarkEnrichJobsAsRead =
  createIpcHook<CronoGatewayBackgroundMarkEnrichJobsAsReadAction>(
    'background-script',
    'markEnrichJobsAsRead',
  );

export const useBackgroundInvalidateAutomatorDelay =
  createIpcHook<CronoGatewayBackgroundInvalidateAutomatorDelay>(
    'background-script',
    'invalidateAutomatorDelay',
  );

export const useBackgroundStartAutomator =
  createIpcHook<CronoGatewayBackgroundStartAutomator>(
    'background-script',
    'startAutomator',
  );

export const useBackgroundSendNotificationToCronoApp =
  createIpcHook<CronoGatewayBackgoundSendNotificationToCronoApp>(
    'background-script',
    'sendNotificationToCronoApp',
  );

export const useBackgroundSaveInTaskContext =
  createIpcHook<CronoGatewayBackgoundSaveInTaskContext>(
    'background-script',
    'saveInTaskContext',
  );

export const useBackgroundGetTaskContextAndClear =
  createIpcHook<CronoGatewayBackgoundGetTaskContextAndClear>(
    'background-script',
    'getTaskContextAndClear',
  );

export const useBackgroundReloadExtension =
  createIpcHook<CronoGatewayBackgroundReloadExtensionAction>(
    'background-script',
    'reloadExtension',
  );

export const useBackgroundManuallyCheckUpdates =
  createIpcHook<CronoGatewayBackgroundCheckUpdatesManually>(
    'background-script',
    'checkUpdatesManually',
  );

export const useGetLinkedinFilterValues =
  createIpcHook<CronoGatewayLinkedinGetFilterValuesAction>(
    'linkedin',
    'getLinkedinFilterValues',
    null,
  );

export const useRefreshCurrentSalesNavCookie =
  createIpcHook<CronoGatewayLinkedinRefreshCurrentSalesNavCookie>(
    'linkedin',
    'refreshCurrentSalesNavCookie',
    null,
  );

export const useBackgroundLoadImage =
  createIpcHook<CronoGatewayBackgroundLoadImageAction>(
    'background-script',
    'loadImage',
  );

export const useGetSalesNavSavedSearchesLeads =
  createIpcHook<CronoGatewaySalesNavGetSavedSearchesLeads>(
    'linkedin',
    'getSalesNavSavedSearchesLeads',
    null,
  );

export const useGetSalesNavSavedSearchesCompanies =
  createIpcHook<CronoGatewaySalesNavGetSavedSearchesCompanies>(
    'linkedin',
    'getSalesNavSavedSearchesCompanies',
    null,
  );

export const useExecuteSalesNavSavedSearchesLeads =
  createIpcHook<CronoGatewaySalesNavExecuteSavedSearchLeads>(
    'linkedin',
    'executeSalesNavSavedSearchesLeads',
    null,
  );

export const useExecuteSalesNavSavedSearchesCompanies =
  createIpcHook<CronoGatewaySalesNavExecuteSavedSearchCompanies>(
    'linkedin',
    'executeSalesNavSavedSearchesCompanies',
    null,
  );
// google
export const useGoogleSearchPlaces =
  createIpcHook<CronoGatewayGoogleSearchPlacesActon>('google', 'searchPlaces');

type CreateIpcHookReturnObject<
  T extends CronoGatewayAction,
  U extends T['params'],
> = {
  call: (params: U) => Promise<T['result'] | null>;
  resetData: () => void;
  error: string | null;
  isLoading: boolean;
  result: T['result'] | null;
};

//This overload signature is used to enforce the types of the parameters depending on the type passed to acceptedIdentifiers
export function createIpcHook<T extends CronoGatewayLinkedinAction>(
  target: T['target'],
  methodName: T['methodName'],
  acceptedIdentifiers: 'prospect',
): () => CreateIpcHookReturnObject<T, CronoGatewayParamsProspect<T>>;

export function createIpcHook<T extends CronoGatewayLinkedinAction>(
  target: T['target'],
  methodName: T['methodName'],
  acceptedIdentifiers: 'account',
): () => CreateIpcHookReturnObject<T, CronoGatewayParamsAccount<T>>;

export function createIpcHook<T extends CronoGatewayLinkedinAction>(
  target: T['target'],
  methodName: T['methodName'],
  acceptedIdentifiers: null,
): () => CreateIpcHookReturnObject<T, T['params']>;

//The generic one for non linkedinAction
export function createIpcHook<
  T extends Exclude<CronoGatewayAction, CronoGatewayLinkedinAction>,
>(
  target: T['target'],
  methodName: T['methodName'],
): () => CreateIpcHookReturnObject<T, T['params']>;

export function createIpcHook<T extends CronoGatewayAction>(
  target: T['target'],
  methodName: T['methodName'],
  acceptedIdentifiers?: 'account' | 'prospect' | null,
) {
  return () => {
    const [hookData, setHookData] = useState<HookData<T>>({
      error: null,
      isLoading: false,
      result: null,
    });

    async function call(params: T['params']): Promise<T['result'] | null> {
      setHookData({
        error: null,
        isLoading: true,
        result: null,
      });
      try {
        const result = await gatewayService.execute({
          target,
          methodName,
          params,
          //We attach the identifier here so that it can be passed to the chrome runtime
          identifiers: acceptedIdentifiers,
        });
        setHookData({
          error: null,
          isLoading: false,
          result,
        });
        return result;
      } catch (e: unknown) {
        const hasMessage = !!e && typeof e === 'object' && 'message' in e;

        if (hasMessage && e.message === 'missingCookie') {
          setHookData({
            error: 'Not logged in in Crono',
            isLoading: false,
            result: null,
          });
        } else if (hasMessage && typeof e.message === 'string') {
          setHookData({
            error: e.message,
            isLoading: false,
            result: null,
          });
        } else {
          setHookData({
            error: 'Unknown error',
            isLoading: false,
            result: null,
          });
        }
        return null;
      }
    }

    return {
      ...hookData,
      call: useCallback(call, []),
      resetData: useCallback(
        () =>
          setHookData({
            error: null,
            isLoading: false,
            result: null,
          }),
        [],
      ),
    };
  };
}

type HookData<T extends CronoGatewayAction> = {
  error: string | null;
  isLoading: boolean;
  result: T['result'] | null;
};

class CronoGatewayService {
  private analytics: Analytics | null = null;
  private usePostMessage = false;

  public setAnalytics(analytics: Analytics | null) {
    this.analytics = analytics;
  }

  public switchToPostMessageStrategy() {
    this.usePostMessage = true;
  }

  public execute<
    T extends CronoGatewayAction,
    _T extends Omit<CronoGatewayAction, 'result'> = Omit<T, 'result'>,
  >(action: _T): Promise<T['result']> {
    if (this.usePostMessage) {
      return this.executeUsingPostMessage(action);
    } else {
      return this.executeUsingChromeRuntime(action);
    }
  }

  private executeUsingChromeRuntime<
    T extends CronoGatewayAction,
    _T extends Omit<CronoGatewayAction, 'result'> = Omit<T, 'result'>,
  >(action: _T): Promise<T['result']> {
    return new Promise((resolve, reject) => {
      let isTimedOut = false;
      const timeout = setTimeout(() => {
        isTimedOut = true;
        reject(new Error('timeout'));
      }, 30000);

      try {
        const callback = (response: CronoGatewayResponse<T>) => {
          if (isTimedOut) return;
          clearTimeout(timeout);
          void this.logErrorToAnalyticsIfNeeded(action, response);
          mapResponseToPromiseResult(resolve, reject, response);
        };

        // @ts-expect-error chrome is not typed in this project
        chrome.runtime.sendMessage(
          getCronoChromeExtensionId(),
          action,
          callback,
        );
      } catch (e) {
        clearTimeout(timeout);
        reject(new Error('extensionNotInstalled'));
      }
    });
  }

  private executeUsingPostMessage<
    T extends CronoGatewayAction,
    _T extends Omit<CronoGatewayAction, 'result'> = Omit<T, 'result'>,
  >(action: _T): Promise<T['result']> {
    return new Promise((resolve, reject) => {
      const cancelToken = { cancelled: false };

      const timeout = setTimeout(() => {
        if (!cancelToken.cancelled) {
          cancelToken.cancelled = true;
          reject(new Error('extensionNotInstalled'));
        }
      }, 10000);

      const id = crypto.randomUUID();
      const listener = (event: MessageEvent) => {
        if (
          event.data.type &&
          event.data.type === 'CRONO_FROM_CONNECTOR' &&
          event.data.id === id &&
          !cancelToken.cancelled
        ) {
          window.removeEventListener('message', listener);
          clearTimeout(timeout);

          const response = event.data.data;
          void this.logErrorToAnalyticsIfNeeded(action, response);
          mapResponseToPromiseResult(resolve, reject, response);
        } else if (cancelToken.cancelled) {
          window.removeEventListener('message', listener);
        }
      };
      window.addEventListener('message', listener, false);

      window.postMessage({ type: 'CRONO_FROM_PAGE', data: action, id }, '*');
    });
  }

  private async logErrorToAnalyticsIfNeeded<
    T extends CronoGatewayAction,
    _T extends Omit<CronoGatewayAction, 'result'> = Omit<T, 'result'>,
  >(action: _T, response?: CronoGatewayResponse<T>) {
    if (!this.analytics || response?.status === 'callSuccess') {
      return;
    }

    const methodSignature = `${action.target}:${action.methodName}` as const;
    const requiredVersion =
      requiredExtensionVersionByActionTargetAndMethodName[methodSignature];
    const installedVersion = await this.getExtensionVersion();

    if (
      requiredVersion &&
      installedVersion &&
      compareVersions(requiredVersion, installedVersion) > 0
    ) {
      await this.analytics.track('extension-not-up-to-date', {
        methodSignature,
        requiredVersion,
        installedVersion,
      });
    } else {
      //For the moment we do not log the pullCronoNotifications error since there are too many and we are waiting to fix it
      if (action.methodName !== 'pullCronoNotifications') {
        await this.analytics.track('crono-gateway-error', {
          action,
          response,
          installedVersion,
        });
      }
    }
  }

  private async getExtensionVersion(): Promise<string | null> {
    return new Promise<string | null>((resolve) => {
      const timeout = setTimeout(() => resolve(null), 5000);
      try {
        // @ts-expect-error chrome is not typed in this project
        chrome.runtime.sendMessage(
          getCronoChromeExtensionId(),
          {
            target: 'background-script',
            methodName: 'getExtensionVersion',
          },
          (response: unknown) => {
            clearTimeout(timeout);
            if (!response) {
              resolve(null);
              return;
            }
            if (typeof response !== 'object') {
              resolve(null);
              return;
            }
            if (!('result' in response)) {
              resolve(null);
              return;
            }
            if (!response.result) {
              resolve(null);
              return;
            }
            if (typeof response.result !== 'object') {
              resolve(null);
              return;
            }
            if (!('version' in response.result)) {
              resolve(null);
              return;
            }
            resolve((response.result.version as string) || null);
          },
        );
      } catch (e) {
        clearTimeout(timeout);
        resolve(null);
      }
    });
  }
}

function mapResponseToPromiseResult<T extends CronoGatewayAction>(
  resolve: (value: T['result']) => void,
  reject: (reason?: unknown) => void,
  response: CronoGatewayResponse<T> | undefined,
) {
  if (!response) {
    reject(new Error('unknownError'));
    return;
  }
  if (response.status !== 'callSuccess') {
    if (response.status === 'tooManyRequests') {
      window.dispatchEvent(new CustomEvent('crono-rate-limited'));
    }
    reject(
      new CronoGatewayError(
        response.reason ?? response.status,
        response.reasonUrl,
      ),
    );
  } else if (
    !response.result &&
    (!('result' in response) || typeof response.result !== 'boolean')
  ) {
    reject(new Error('unknownError'));
  } else {
    resolve(response.result);
  }
}

export const gatewayService = new CronoGatewayService();
